<div class="flex flex-row items-center cursor-pointer" (click)="toggle()" (keypress)="{}" tabindex="0">
    <div class="w-[18px] h-[18px] flex justify-center items-center  border-[1px] rounded border-[var(--header-border)]"
        [ngClass]="{' bg-[var(--btn-bg-secondary)]': !fill, ' bg-[var(--checkbox-bg)] border-none': fill && value,
            'w-[22px] h-[22px] rounded-md ': size === 'M',
        }">
        @if (value) {
            <svg-icon name="checkbox" [size]=" size === 'S' ? 'MINI' : 'XS'"
                [color]="fill ? 'var(--white)' : 'var(--btn-txt-secondary)'"></svg-icon>
        }
    </div>
    @if (label) {
        <span class="text-[var(--text-primary)] ml-2 font-semibold text-base">{{ label }}</span>
    }
</div>
